import { createFileRoute } from '@tanstack/react-router';
import { ShipmentNewPage, type NewShipmentHandoff } from '../../features/shipments';

const HS_RE = /^[0-9]{6,10}$/;
const CC_RE = /^[A-Za-z]{2}$/;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * `?hsCode=&description=&originCountry=&classificationId=` seeds the draft's first cargo line from an
 * HS classification (the classifier "New shipment" handoff). Validated and clamped here; the page
 * forwards it to the API as a HandoffHsClassification.
 */
export const Route = createFileRoute('/portal/shipments/new')({
  validateSearch: (s: Record<string, unknown>): { handoff?: NewShipmentHandoff } => {
    const hsCode = typeof s.hsCode === 'string' && HS_RE.test(s.hsCode) ? s.hsCode : undefined;
    const description =
      typeof s.description === 'string' && s.description.trim() ? s.description.trim().slice(0, 2000) : undefined;
    if (!hsCode || !description) return {};
    return {
      handoff: {
        hsCode,
        description,
        ...(typeof s.originCountry === 'string' && CC_RE.test(s.originCountry)
          ? { originCountry: s.originCountry.toUpperCase() }
          : {}),
        ...(typeof s.classificationId === 'string' && UUID_RE.test(s.classificationId)
          ? { classificationId: s.classificationId }
          : {}),
      },
    };
  },
  component: function ShipmentNewRoute() {
    const { handoff } = Route.useSearch();
    return <ShipmentNewPage {...(handoff ? { handoff } : {})} />;
  },
});
